import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { auxiliaryMachines } from '../../mock/mockData';

const StickerLabelling = () => {
  const productData = auxiliaryMachines.find(p => p.id === 'sticker-labelling');
  return <ProductPageTemplate productData={productData} />;
};

export default StickerLabelling;